import React, { useState, useEffect } from "react";
import "./App.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routes"; // auto-generated by TanStack
import CustomCursor from "./components/CustomCursor";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";
import PerformanceMonitor from "./components/PerformanceMonitor";
import { AuthProvider } from "./hooks/useAuth";
import SEO from "./components/SEO";
import { UISniper } from "ui-sniper";
import { ModalProvider } from "./components/ui/ModalProvider";

// Create router instance
const router = createRouter({ routeTree });

function App() {
  const [showSniper, setShowSniper] = useState(false);
  const [showMobileFeedback, setShowMobileFeedback] = useState(false);

  useEffect(() => {
    const keys = new Set();
    const handleKeyDown = (e) => {
      if (!e.key) return;
      keys.add(e.key.toLowerCase());
      if (keys.has("f") && keys.has("1")) {
        setShowSniper(prev => !prev);
      }
    };
    const handleKeyUp = (e) => {
      if (!e.key) return;
      keys.delete(e.key.toLowerCase());
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  useEffect(() => {
    let lastX = null, lastY = null, lastZ = null;
    const threshold = 15;
    
    const handleMotion = (e) => {
      const { accelerationIncludingGravity } = e;
      if (!accelerationIncludingGravity) return;
      const { x, y, z } = accelerationIncludingGravity;
      if (x === null || y === null || z === null) return;
      
      if (lastX !== null) {
        const deltaX = Math.abs(lastX - x);
        const deltaY = Math.abs(lastY - y);
        const deltaZ = Math.abs(lastZ - z);
        
        if (deltaX + deltaY + deltaZ > threshold) {
          setShowMobileFeedback(true);
        }
      }
      lastX = x;
      lastY = y;
      lastZ = z;
    };
    
    window.addEventListener("devicemotion", handleMotion);
    return () => window.removeEventListener("devicemotion", handleMotion);
  }, []);

  return (
    <ErrorBoundary>
      <ModalProvider>
        <AuthProvider>
          <div className="App relative cursor-none">
          <SEO />
          <PerformanceMonitor />
          <CustomCursor />
          <RouterProvider router={router} />
          <Toaster />
          {showSniper && <UISniper />}
          {showMobileFeedback && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
              <div className="bg-white p-6 rounded-lg shadow-xl text-black max-w-sm w-full">
                <h2 className="text-xl font-bold mb-2">Feedback</h2>
                <p className="mb-4">Please leave your feedback below.</p>
                <button 
                  onClick={() => setShowMobileFeedback(false)}
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
        </AuthProvider>
      </ModalProvider>
    </ErrorBoundary>
  );
}

export default App;
